<script>
    import TextField from '../form/TextField.svelte';
    import HelperText from '@smui/textfield/helper-text/index';

    export let hours = 0;
    export let minutes = 0;
</script>

<div class="wrapper">
    <TextField
            bind:value={hours}
            label="Hours"
            type="number"
            variant="outlined"
            min="0"
            max="100"
    />
    <TextField
            bind:value={minutes}
            label="Minutes"
            type="number"
            variant="outlined"
            min="0"
            max="60"
    />
</div>

<HelperText>
    Number of hours worked.
</HelperText>

<style>
    .wrapper {
        display: flex;
        flex-direction: row;
    }

    .wrapper > * {
        flex: 1;
    }
</style>